import { Box, SxProps, Typography } from '@mui/material';
import { FunctionComponent } from 'react';



interface ChipLayerProps {
	label?: string
	selected?: boolean
	readonly?: boolean
	disabled?: boolean
	onClick?: () => void
}

/**
 * Permette di visualizzare il nome di un layer in tutta la sua bellezza
 */
const ChipLayerCmp: FunctionComponent<ChipLayerProps> = ({
	label,
	selected,
	readonly,
	disabled,
	onClick,
}) => {

	const sxDisabled: SxProps = disabled
		? { bgcolor: "text.disabled" }
		: {
			bgcolor: "secondary.main",
			cursor: "pointer",
			"&:hover": { bgcolor: "secondary.dark" },
		}
	const sxSelected: SxProps = selected 
		? { bgcolor: "#fff", "&:hover": { bgcolor: "#fff" }, } 
		: {}

	const sxReadonly : SxProps = readonly
		? { pointerEvents: "none" }
		: {}


	return (
		<Box sx={[sxChip, sxDisabled, sxSelected, sxReadonly] as SxProps}
			onClick={onClick}
		>
			<Typography variant="caption" color="secondary.contrastText">
				{label}
			</Typography>
		</Box>
	)
}

export default ChipLayerCmp

const sxChip: SxProps = {
	borderRadius: "4px",
	padding: "2px 7px 0px 7px",
	display: "flex",
	alignItems: "center",
	flexDirection: "column",
}